import {UserType} from '@legit.health/ui';

export default function isPatientType(type: string) {
  return type === UserType.Patient;
}
